import loadable from '@loadable/component';
import { FC } from 'react';
import { HttpStatusCode } from '@cp/utils/const/httpStatusCode';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { coreCatalogItemApi } from '@cp/entities/catalogItem';
import { useCurrentCity } from '@cp/entities/location';
import { ReactAppPageNotFoundError } from '@common/model/reactApp/error';
import { useClientWebRouteProps } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useIsLoggedIn } from '@cp/entities/currentUser';
import { CatalogItemPageProps, CatalogItemPageViewProps } from './model';

const ResumeView = loadable(() => import('./view.resume'));
const VacancyView = loadable(() => import('./view.vacancy'));

const CatalogItemPage: FC<CatalogItemPageProps> = (props) => {
  const { match } = props;
  const isLoggedIn = useIsLoggedIn();
  const pageProps = useClientWebRouteProps<ClientWebPage.CatalogItem>();
  const { catalogType, careerId } = pageProps;
  const id = Number(match.params.id || 'NaN'); // Should be NaN for '' | 'nannies-123' | null | undefiend etc
  const { currentCity } = useCurrentCity();
  const { data, isLoading, error } = coreCatalogItemApi.useGetByIdQuery({ id }, { skip: !currentCity || Number.isNaN(id) });

  // Errors
  const noIdOrCity = !currentCity || Number.isNaN(id);
  const noCityInTheData = data?.city && data.city.id !== currentCity.id;
  const noCatalogTypeInTheData = data?.type && data.type !== catalogType;
  const noCareerIdInTheData = data?.careerId && data.careerId !== careerId;
  const hasError = typeof error === 'object' && error && 'status' in error && error.status === HttpStatusCode.NotFound;

  if (hasError || noCityInTheData || noCatalogTypeInTheData || noCareerIdInTheData || noIdOrCity) {
    throw new ReactAppPageNotFoundError({
      status: noIdOrCity ? HttpStatusCode.NotFound : HttpStatusCode.Gone,
      providers: { footer: true, app: true, city: currentCity.alias },
    });
  }

  const isResume = catalogType === CatalogItemType.Resume;
  const viewProps: CatalogItemPageViewProps = { pageProps, id, data, isLoading, disableInfo: !isLoggedIn };
  const View = isResume ? ResumeView : VacancyView;
  return <View {...viewProps} />;
};

export default CatalogItemPage;
